// Used by react-dnd
export const ItemTypes = {
  CARD: 'card',
}



// WEBPACK FOOTER //
// ./src/Types/ItemTypes.js